
import { MapPin, Clock, Phone } from 'lucide-react';
import { DogSchool } from '@/data/dogSchools';
import { useLanguage } from '@/contexts/LanguageContext';

interface SchoolBasicInfoProps {
  school: DogSchool;
  formattedAddress: string;
}

export const SchoolBasicInfo = ({ school, formattedAddress }: SchoolBasicInfoProps) => {
  const { t } = useLanguage();
  
  // Use either phoneNumber or phone property
  const phoneNumber = school.phoneNumber || school.phone;
  
  return (
    <div className="space-y-3">
      <div className="flex items-start space-x-3">
        <MapPin className="h-5 w-5 text-gray-500 mt-0.5 flex-shrink-0" />
        <span className="text-gray-600">
          {formattedAddress}
        </span>
      </div>
      
      <div className="flex items-start space-x-3">
        <Clock className="h-5 w-5 text-gray-500 mt-0.5 flex-shrink-0" />
        <div className="text-gray-600 whitespace-pre-line">
          {school.openingHours?.de || t('noOpeningHours')}
        </div>
      </div>
      
      {phoneNumber && (
        <div className="flex items-start space-x-3">
          <Phone className="h-5 w-5 text-gray-500 mt-0.5 flex-shrink-0" />
          <a 
            href={`tel:${phoneNumber}`} 
            className="text-primary hover:underline hover:text-primary/80 transition-colors"
          >
            {phoneNumber}
          </a>
        </div>
      )}
    </div>
  );
};
